var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptionsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 13,
    viewBox: "0 0 4 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66211 2.98535C2.45508 2.98535 3.07031 2.37012 3.07031 1.56348C3.07031 0.791015 2.44141 0.155273 1.66211 0.155273C0.896484 0.155273 0.253906 0.791015 0.253906 1.56348C0.253906 2.34277 0.896484 2.98535 1.66211 2.98535ZM1.66211 7.81836C2.45508 7.81836 3.07031 7.20312 3.07031 6.41016C3.07031 5.6377 2.44141 5.00879 1.66211 5.00879C0.896484 5.00879 0.253906 5.63769 0.253906 6.41016C0.253906 7.17578 0.896484 7.81836 1.66211 7.81836ZM1.66211 12.665C2.45508 12.665 3.07031 12.0498 3.07031 11.2568C3.07031 10.4707 2.44141 9.83496 1.66211 9.83496C0.896484 9.83496 0.253906 10.4707 0.253906 11.2568C0.253906 12.0225 0.896484 12.665 1.66211 12.665Z",
    fill: "#18A28F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsIcon);
export default __webpack_public_path__ + "static/media/options-icon.caaea949.svg";
export { ForwardRef as ReactComponent };